import { useAppDispatch } from 'shared/lib/redux';

import { setAssignmentActionTimestamp } from '../../model';

export const useAssignmentActionTimestampHandlers = () => {
  const dispatch = useAppDispatch();

  /*
   * write timestamp of last assignment action
   * to trigger invalidationCallback call inside useAssignmentsQueryInvalidation hook
   * */
  const writeAssignmentActionTimestamp = () => {
    dispatch(setAssignmentActionTimestamp(new Date().getTime()));
  };

  const clearAssignmentActionTimestamp = () => {
    dispatch(setAssignmentActionTimestamp(null));
  };

  return {
    writeAssignmentActionTimestamp,
    clearAssignmentActionTimestamp,
  };
};
